<template>
  <div v-if="isVisible" class="modal-overlay" @click.self="close">
    <div class="modalJ">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Modal',
  props: {
    isVisible: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close'],
  methods: {
    close() {
      this.$emit('close');
    }
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(10, 14, 20, 0.6);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  display: flex;
  justify-content: center;
  align-items: flex-end;
  z-index: 2;
  padding: 0;
}

.modalJ {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  background: #ffffff;
  padding: 16px;
  border-radius: 20px 20px 0 0;
  box-shadow: 0 -4px 32px rgba(0, 0, 0, 0.12);
  gap: 12px;
  width: 100%;
  max-width: 560px;
  position: relative;
  max-height: 82vh;
  overflow-y: auto;
  animation: modal-in 200ms cubic-bezier(0.32, 0.72, 0, 1);
}

@media (min-width: 600px) {
  .modal-overlay {
    align-items: center;
    padding: 16px;
  }

  .modalJ {
    border-radius: 16px;
    box-shadow: 0 8px 40px rgba(0, 0, 0, 0.16), 0 2px 8px rgba(0, 0, 0, 0.06);
    animation: modal-in-center 180ms cubic-bezier(0.32, 0.72, 0, 1);
  }
}

@keyframes modal-in {
  0% { transform: translateY(100%); opacity: 0.6; }
  100% { transform: translateY(0); opacity: 1; }
}

@keyframes modal-in-center {
  0% { transform: translateY(6px) scale(0.97); opacity: 0; }
  100% { transform: translateY(0) scale(1); opacity: 1; }
}
</style>
